import TeacherLessonsIndex from '@/views/teacherLessons/TeacherLessonsIndex.vue';
import RecordTeacherLessons from '@/views/teacherLessons/RecordTeacherLessons.vue';

export default [
  {
    path: '/teacher-lessons',
    name: 'teacher-lessons.index',
    component: TeacherLessonsIndex,
    meta: {
      title: 'teacherLessons.indexTitle',
      requiresAuth: true,
      requiredPerm: 'teacher_lessons.display',
    },
    children: [
      {
        path: '/teacher-lessons/record',
        name: 'teacher-lessons.record',
        component: RecordTeacherLessons,
        meta: {
          title: 'teacherLessons.recordTitle',
          requiresAuth: true,
          requiredPerm: 'teacher_lessons.create',
        }
      }
    ]
  },
];
